import { useEffect } from 'react';
import { Link, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { AUTH_EXPIRED_EVENT } from './api/client';
import { RequireAuth } from './auth/RequireAuth';
import { hasAuthToken, removeAuthToken } from './auth/token';
import { LoginPage } from './pages/LoginPage';
import { ProfilePage } from './pages/ProfilePage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectEditorPage } from './pages/ProjectEditorPage';

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoginPage = location.pathname === '/login';
  const isEditorPage = /^\/projects\/[^/]+$/.test(location.pathname);
  const isAuthenticated = hasAuthToken();

  useEffect(() => {
    function handleAuthExpired() {
      removeAuthToken();

      if (location.pathname === '/login') {
        return;
      }

      navigate('/login', {
        replace: true,
        state: {
          from: {
            pathname: `${location.pathname}${location.search}${location.hash}`,
          },
        },
      });
    }

    window.addEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);
    return () => window.removeEventListener(AUTH_EXPIRED_EVENT, handleAuthExpired);
  }, [location.hash, location.pathname, location.search, navigate]);

  function handleLogout() {
    removeAuthToken();
    navigate('/login', { replace: true });
  }

  return (
    <div className={isLoginPage ? undefined : isEditorPage ? 'app-shell app-shell--editor' : 'app-shell'}>
      {!isLoginPage ? (
        <>
          <header
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}
          >
            {isEditorPage ? (
              <div className="app-editor-brand">
                <h1 className="app-editor-brand__title">Piperix</h1>
                <Link className="app-editor-brand__back" to="/projects">
                  Назад к списку проектов
                </Link>
              </div>
            ) : (
              <div>
                <h1 style={{ marginBottom: '8px' }}>Piperix</h1>
                <p style={{ marginTop: 0 }}>Рабочая область проектов</p>
              </div>
            )}
            {isAuthenticated ? (
              <div style={{ display: 'flex', gap: '8px' }}>
                <Link
                  to="/profile"
                  className={location.pathname === '/profile' ? 'btn btn-active' : 'btn'}
                  aria-current={location.pathname === '/profile' ? 'page' : undefined}
                >
                  Кабинет
                </Link>
                <button type="button" className="btn btn-danger" onClick={handleLogout}>
                  Выйти
                </button>
              </div>
            ) : null}
          </header>
          {isEditorPage ? null : (
            <nav style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
              <Link to="/projects">/projects</Link>
            </nav>
          )}
        </>
      ) : null}

      <div className="app-shell__content">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireAuth />}>
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:id" element={<ProjectEditorPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Route>
        <Route path="*" element={<Navigate to={isAuthenticated ? '/projects' : '/login'} replace />} />
      </Routes>
      </div>
    </div>
  );
}

export default App;